import {ProtectedRoute} from "../../common/route/ProtectedRoute";

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
    return (
        <ProtectedRoute allowedRoles={['ADMIN']}>
            {children}
        </ProtectedRoute>
    );
};